import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/layout/index.vue'
import Home from '@/views/Home/index.vue'
import Login from '@/views/Login/index.vue'

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'channeldata',
        name: 'channeldata',
        component: () => import(/* webpackChunkName: "data" */ '../views/Data/channeldata.vue'),
        meta: {
          title: 'channeldata',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'retaineduser',
        name: 'retaineduser',
        component: () => import(/* webpackChunkName: "data" */ '../views/Data/Retaineduser.vue'),
        meta: {
          title: 'retaineduser',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'revenuedata',
        name: 'revenuedata',
        component: () => import(/* webpackChunkName: "data" */ '../views/Data/Revenue.vue'),
        meta: {
          title: 'revenuedata',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'revenuedataNew',
        name: 'revenuedataNew',
        component: () => import(/* webpackChunkName: "data" */ '../views/Data/RuleGroup/Revenue/index.vue'),
        meta: {
          title: 'revenuedataNew',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'payuserdata',
        name: 'payuserdata',
        component: () => import(/* webpackChunkName: "data" */ '../views/Data/Payuser.vue'),
        meta: {
          title: 'payuserdata',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'payuserdataNew',
        name: 'payuserdataNew',
        component: () => import(/* webpackChunkName: "data" */ '../views/Data/RuleGroup/Payuser/index.vue'),
        meta: {
          title: 'payuserdataNew',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'retaineduserNew',
        name: 'retaineduserNew',
        component: () => import(/* webpackChunkName: "data" */ '../views/Data/RuleGroup/Retaineduser/index.vue'),
        meta: {
          title: 'retaineduserNew',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: '/home',
        name: 'home',
        component: Home,
        meta: {
          title: 'home',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'rechargeFlow',
        name: 'rechargeFlow',
        component: () => import(/* webpackChunkName: "user" */ '../views/User/recharge/index.vue'),
        meta: {
          title: 'recharge',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'channelManage',
        name: 'channelManage',
        component: () => import(/* webpackChunkName: "user" */ '../views/channelManage/index.vue'),
        meta: {
          title: 'channelManage',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'exportExcelManager',
        name: 'exportExcelManager',
        component: () => import(/* webpackChunkName: "user" */ '../views/export/index.vue'),
        meta: {
          title: 'exportExcelManager',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'consumerFlow',
        name: 'consumerFlow',
        component: () => import(/* webpackChunkName: "user" */ '../views/User/consumer/index.vue'),
        meta: {
          title: 'consumer',
          icon: 'guide',
          noCache: true
        }
      }, {
        path: 'consumerFastFlow',
        name: 'consumerFastFlow',
        component: () => import(/* webpackChunkName: "user" */ '../views/User/consumer-fast/index.vue'),
        meta: {
          title: 'consumer',
          icon: 'guide',
          noCache: true
        }
      }, {
        path: 'scoreFastFlow',
        name: 'scoreFastFlow',
        component: () => import(/* webpackChunkName: "user" */ '../views/User/score-fast/index.vue'),
        meta: {
          title: 'consumer',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'scoreFlow',
        name: 'scoreFlow',
        component: () => import(/* webpackChunkName: "user" */ '../views/User/score/index.vue'),
        meta: {
          title: 'consumer',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'selfIntroduction',
        name: 'selfIntroduction',
        component: () => import(/* webpackChunkName: "user" */ '../views/selfIntroduction/index.vue'),
        meta: {
          title: 'selfIntroduction',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'moreIpAlarm',
        name: 'moreIpAlarm',
        component: () => import(/* webpackChunkName: "user" */ '../views/alarm/moreIpAlarm/index.vue'),
        meta: {
          title: 'moreIpAlarm',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'moreDeviceAlarm',
        name: 'moreDeviceAlarm',
        component: () => import(/* webpackChunkName: "user" */ '../views/alarm/moreDeviceAlarm/index.vue'),
        meta: {
          title: 'moreDeviceAlarm',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'ipDeviceAlarm',
        name: 'ipDeviceAlarm',
        component: () => import(/* webpackChunkName: "user" */ '../views/alarm/ipDeviceAlarm/index.vue'),
        meta: {
          title: 'alarm',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'packageGift',
        name: 'packageGift',
        component: () => import(/* webpackChunkName: "user" */ '../views/User/packageGift/index.vue'),
        meta: {
          title: 'packageGift',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'lotteryTicket',
        name: 'lotteryTicket',
        component: () => import(/* webpackChunkName: "user" */ '../views/User/lotteryTicket/index.vue'),
        meta: {
          title: 'lotteryTicket',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'redMumSetting',
        name: 'redMumSetting',
        component: () => import(/* webpackChunkName: "user" */ '../views/setting/redMumSetting/index.vue'),
        meta: {
          title: 'redMumSetting',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'outExport',
        name: 'outExport',
        component: () => import(/* webpackChunkName: "user" */ '../views/outExport/index.vue'),
        meta: {
          title: 'outExport',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'redMumPushSetting',
        name: 'redMumPushSetting',
        component: () => import(/* webpackChunkName: "user" */ '../views/setting/redMumPushSetting/index.vue'),
        meta: {
          title: 'redMumPushSetting',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'indexListSetting',
        name: 'indexListSetting',
        component: () => import(/* webpackChunkName: "user" */ '../views/setting/indexListSetting/index.vue'),
        meta: {
          title: 'indexListSetting',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'mediaTaskSetting',
        name: 'mediaTaskSetting',
        component: () => import(/* webpackChunkName: "user" */ '../views/setting/mediaTaskSetting/index.vue'),
        meta: {
          title: 'mediaTaskSetting',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'user',
        name: 'user',
        component: () => import(/* webpackChunkName: "user" */ '../views/User/index.vue'),
        meta: {
          title: 'user',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'messagePatrol',
        name: 'messagePatrol',
        component: () => import(/* webpackChunkName: "user" */ '../views/User/messagePatrol/index.vue'),
        meta: {
          title: 'user',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'authentication',
        name: 'authentication',
        component: () => import(/* webpackChunkName: "authentication" */ '../views/Authentication/index.vue'),
        meta: {
          title: 'authentication',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'authenticationAuth',
        name: 'authenticationAuth',
        component: () => import(/* webpackChunkName: "authentication" */ '../views/Authentication/Cert/index.vue'),
        meta: {
          title: 'authenticationAuth',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'team',
        name: 'team',
        component: () => import(/* webpackChunkName: "team" */ '../views/Team/index.vue'),
        meta: {
          title: 'team',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: '/team/overview',
        name: 'teamoverview',
        component: () => import(/* webpackChunkName: "team" */ '../views/Team/overview.vue'),
        meta: {
          title: 'team',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: '/team/day',
        name: 'teamday',
        component: () => import(/* webpackChunkName: "team" */ '../views/Team/day.vue'),
        meta: {
          title: 'team',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: '/team/member',
        name: 'teammember',
        component: () => import(/* webpackChunkName: "team" */ '../views/Team/member.vue'),
        meta: {
          title: 'team',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: '/team/relate',
        name: 'relate',
        component: () => import(/* webpackChunkName: "team" */ '../views/Team/relate/index.vue'),
        meta: {
          title: 'relate',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'pgcVideoAudit',
        name: 'pgcVideoAudit',
        component: () => import(/* webpackChunkName: "pgc" */ '../views/PGC/pgcVideoAudit/index.vue'),
        meta: {
          title: 'pgcVideoAudit',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'pgcGoddess',
        name: 'pgcGoddess',
        component: () => import(/* webpackChunkName: "pgc" */ '../views/PGC/pgcGoddess/index.vue'),
        meta: {
          title: 'pgcGoddess',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'pgc',
        name: 'pgc',
        component: () => import(/* webpackChunkName: "pgc" */ '../views/PGC/index.vue'),
        meta: {
          title: 'pgcAdmin',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'level',
        name: 'level',
        component: () => import(/* webpackChunkName: "level" */ '../views/Level/index.vue'),
        meta: {
          title: 'level',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'level/cost',
        name: 'cost',
        component: () => import(/* webpackChunkName: "level" */ '../views/Level/cost.vue'),
        meta: {
          title: 'cost',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'level/profit',
        name: 'profit',
        component: () => import(/* webpackChunkName: "level" */ '../views/Level/profit.vue'),
        meta: {
          title: 'profit',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'level/gradient',
        name: 'gradient',
        component: () => import(/* webpackChunkName: "level" */ '../views/Level/profitGradient.vue'),
        meta: {
          title: 'gradient',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'goddess-level-cost',
        name: 'goddess-level-cost',
        component: () => import(/* webpackChunkName: "level" */ '../views/goddess/cost.vue'),
        meta: {
          title: 'goddess-level-cost',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'goddess-level-profit',
        name: 'goddess-level-profit',
        component: () => import(/* webpackChunkName: "level" */ '../views/goddess/profit.vue'),
        meta: {
          title: 'goddess-level-profit',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'goddess-level',
        name: 'goddess-level',
        component: () => import(/* webpackChunkName: "level" */ '../views/goddess/index.vue'),
        meta: {
          title: 'goddess-level',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'gift',
        name: 'gift',
        component: () => import(/* webpackChunkName: "gift" */ '../views/Gift/index.vue'),
        meta: {
          title: 'gift',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'task',
        name: 'task',
        component: () => import(/* webpackChunkName: "task" */ '../views/Task/index.vue'),
        meta: {
          title: 'task',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'lottery',
        name: 'lottery',
        component: () => import(/* webpackChunkName: "banner" */ '../views/Lottery/index.vue'),
        meta: {
          title: 'lottery',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'statictics',
        name: 'statictics',
        component: () => import(/* webpackChunkName: "banner" */ '../views/Lottery/statictics.vue'),
        meta: {
          title: 'statictics',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'banner',
        name: 'banner',
        component: () => import(/* webpackChunkName: "banner" */ '../views/Banner/index.vue'),
        meta: {
          title: 'banner',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'payParamConfig',
        name: 'payParamConfig',
        component: () => import(/* webpackChunkName: "banner" */ '../views/PayConfig/index.vue'),
        meta: {
          title: 'payConfig',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'payLimitConfig',
        name: 'payLimitConfig',
        component: () => import(/* webpackChunkName: "banner" */ '../views/PayConfig/limit/index.vue'),
        meta: {
          title: 'payLimitConfig',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'floatingWidget',
        name: 'floatingWidget',
        component: () => import(/* webpackChunkName: "banner" */ '../views/FloatingWidget/index.vue'),
        meta: {
          title: 'floatingWidget',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'ulog',
        name: 'ulog',
        component: () => import(/* webpackChunkName: "ulog" */ '../views/Ulog/index.vue'),
        meta: {
          title: 'ulog',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'ulogTop',
        name: 'ulogTop',
        component: () => import(/* webpackChunkName: "ulog" */ '../views/Ulog/Top/index.vue'),
        meta: {
          title: 'ulogTop',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: '/ulogDetail/:id',
        name: 'ulogDetail',
        component: () => import(/* webpackChunkName: "ulog" */ '../views/Ulog/detail/index.vue'),
        meta: {
          title: 'ulogDetail',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: '/superManager/:id',
        name: 'deimos',
        component: () => import(/* webpackChunkName: "ulog" */ '../views/deimos/index.vue'),
        meta: {
          title: 'deimos',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'copywriting',
        name: 'copywriting',
        component: () => import(/* webpackChunkName: "copywriting" */ '../views/Copywriting/index.vue'),
        meta: {
          title: 'copywriting',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'money',
        name: 'money',
        component: () => import(/* webpackChunkName: "money" */ '../views/Money/index.vue'),
        meta: {
          title: 'money',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'ruleGroup',
        name: 'ruleGroup',
        component: () => import(/* webpackChunkName: "money" */ '../views/RuleGroup/index.vue'),
        meta: {
          title: 'ruleGroup',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'advertisingPicture',
        name: 'advertisingPicture',
        component: () => import(/* webpackChunkName: "money" */ '../views/Picture/index.vue'),
        meta: {
          title: 'advertisingPicture',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'grant',
        name: 'grant',
        component: () => import(/* webpackChunkName: "grant" */ '../views/Money/grant.vue'),
        meta: {
          title: 'grant',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'deductScoreNew',
        name: 'deductScoreNew',
        component: () => import(/* webpackChunkName: "grant" */ '../views/Money/components/deductScoreNew.vue'),
        meta: {
          title: 'deductScoreNew',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'gold',
        name: 'gold',
        component: () => import(/* webpackChunkName: "grant" */ '../views/Money/gold.vue'),
        meta: {
          title: 'gold',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'pgc-level-modify',
        name: 'pgc-level-modify',
        component: () => import(/* webpackChunkName: "grant" */ '../views/PGC/pgc-level/pgc-level-modify.vue'),
        meta: {
          title: 'pgc-level-modify',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'goddess-level-modify',
        name: 'goddess-level-modify',
        component: () => import(/* webpackChunkName: "goddess" */ '../views/goddess/goddess-level-modify/index.vue'),
        meta: {
          title: 'goddess-level-modify',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'scoreDraw',
        name: 'scoreDraw',
        component: () => import(/* webpackChunkName: "grant" */ '../views/User/scoreDraw/index.vue'),
        meta: {
          title: 'scoreDraw',
          icon: 'home',
          noCache: true
        }
      },
      {
        path: 'scoreDrawAudit',
        name: 'scoreDrawAudit',
        component: () => import(/* webpackChunkName: "grant" */ '../views/User/scoreDrawAudit/index.vue'),
        meta: {
          title: 'scoreDrawAudit',
          icon: 'home',
          noCache: true
        }
      },
      {
        path: 'punish',
        name: 'punish',
        component: () => import(/* webpackChunkName: "user" */ '../views/User/punish/index.vue'),
        meta: {
          title: 'punish',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'report',
        name: 'report',
        component: () => import(/* webpackChunkName: "user" */ '../views/User/report/index.vue'),
        meta: {
          title: 'report',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'headPicManualAudit',
        name: 'headPicManualAudit',
        component: () => import(/* webpackChunkName: "user" */ '../views/User/headPicManualAudit/index.vue'),
        meta: {
          title: 'headPicManualAudit',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'functionLimit',
        name: 'functionLimit',
        component: () => import(/* webpackChunkName: "user" */ '../views/User/functionLimit/index.vue'),
        meta: {
          title: 'functionLimit',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'albumAudit',
        name: 'albumAudit',
        component: () => import(/* webpackChunkName: "user" */ '../views/User/albumAudit/index.vue'),
        meta: {
          title: 'albumAudit',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'personalitySignAudit',
        name: 'personalitySignAudit',
        component: () => import(/* webpackChunkName: "user" */ '../views/User/personalitySignAudit/index.vue'),
        meta: {
          title: 'personalitySignAudit',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'functionLimitRecord',
        name: 'functionLimitRecord',
        component: () => import(/* webpackChunkName: "user" */ '../views/User/functionLimitRecord/index.vue'),
        meta: {
          title: 'functionLimitRecord',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'realManCheck',
        name: 'realManCheck',
        component: () => import(/* webpackChunkName: "user" */ '../views/RealManCheck/index.vue'),
        meta: {
          title: 'realManCheck',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'livePersonCheck',
        name: 'livePersonCheck',
        component: () => import(/* webpackChunkName: "user" */ '../views/LivePersonCheck/index.vue'),
        meta: {
          title: 'livePersonCheck',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'accountExtraFunction',
        name: 'accountExtraFunction',
        component: () => import(/* webpackChunkName: "user" */ '../views/AccountExtraFunction/index.vue'),
        meta: {
          title: 'accountExtraFunction',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'admin',
        name: 'admin',
        component: () => import(/* webpackChunkName: "user" */ '../views/admin/index.vue'),
        meta: {
          title: 'admin',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'apiLog',
        name: 'apiLog',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/apiLog/index.vue'),
        meta: {
          title: '后台管理接口日志',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'bizSwitch',
        name: 'bizSwitch',
        component: () => import(/* webpackChunkName: "bizswitch" */ '../views/BizSwitch/index.vue'),
        meta: {
          title: '业务开关',
          icon: 'guide',
          noCache: true
        }
      },
      // 流量分配：分级 / 固定名单 / 首页预览 / 匹配 / 事件（后端 /admin/{tier,home,accost,match,event}）
      {
        path: 'trafficTierStats',
        name: 'trafficTierStats',
        component: () => import(/* webpackChunkName: "traffic" */ '../views/Traffic/TierStats/index.vue'),
        meta: {
          title: '分级总览',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'trafficTierUser',
        name: 'trafficTierUser',
        component: () => import(/* webpackChunkName: "traffic" */ '../views/Traffic/TierUser/index.vue'),
        meta: {
          title: '用户分级',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'trafficPin',
        name: 'trafficPin',
        component: () => import(/* webpackChunkName: "traffic" */ '../views/Traffic/TierPin/index.vue'),
        meta: {
          title: '固定分级名单',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'trafficHomePreview',
        name: 'trafficHomePreview',
        component: () => import(/* webpackChunkName: "traffic" */ '../views/Traffic/HomePreview/index.vue'),
        meta: {
          title: '首页预览',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'trafficMatch',
        name: 'trafficMatch',
        component: () => import(/* webpackChunkName: "traffic" */ '../views/Traffic/MatchMonitor/index.vue'),
        meta: {
          title: '匹配监控',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'trafficEvent',
        name: 'trafficEvent',
        component: () => import(/* webpackChunkName: "traffic" */ '../views/Traffic/EventQuery/index.vue'),
        meta: {
          title: '事件查询',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import(/* webpackChunkName: "user" */ '../views/role/index.vue'),
        meta: {
          title: 'admin',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'permission',
        name: 'permission',
        component: () => import(/* webpackChunkName: "user" */ '../views/Permission/index.vue'),
        meta: {
          title: 'permission',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'channels',
        name: 'channels',
        component: () => import(/* webpackChunkName: "channel" */ '../views/Channel/index.vue'),
        meta: {
          title: 'channels',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'payTypeConfig',
        name: 'payTypeConfig',
        component: () => import(/* webpackChunkName: "channel" */ '../views/setting/payTypeConfig/index.vue'),
        meta: {
          title: 'payTypeConfig',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'channel',
        name: 'channel',
        component: () => import(/* webpackChunkName: "channel" */ '../views/Channel/channel.vue'),
        meta: {
          title: 'channel',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'ipForbidden',
        name: 'ipForbidden',
        component: () => import(/* webpackChunkName: "channel" */ '../views/User/ipForbidden/index.vue'),
        meta: {
          title: 'ipForbidden',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'ipForbiddenRecord',
        name: 'ipForbiddenRecord',
        component: () => import(/* webpackChunkName: "channel" */ '../views/User/ipForbiddenRecord/index.vue'),
        meta: {
          title: 'ipForbiddenRecord',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'promo_user',
        name: 'promoUser',
        component: () => import(/* webpackChunkName: "channel" */ '../views/Channel/promoUser.vue'),
        meta: {
          title: 'promoUser',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'promo_retain',
        name: 'promoRetain',
        component: () => import(/* webpackChunkName: "channel" */ '../views/Channel/promoRetain.vue'),
        meta: {
          title: 'promoRetain',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'pgcEfficiencyStat',
        name: 'pgcEfficiencyStat',
        component: () => import(/* webpackChunkName: "channel" */ '../views/msgStat/pgcEfficiencyStat/index.vue'),
        meta: {
          title: 'pgcEfficiencyStat',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'queryRealMobile',
        name: 'queryRealMobile',
        component: () => import(/* webpackChunkName: "channel" */ '../views/User/queryRealMobile/index.vue'),
        meta: {
          title: 'queryRealMobile',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'queryRealMobileRecord',
        name: 'queryRealMobileRecord',
        component: () => import(/* webpackChunkName: "channel" */ '../views/User/queryRealMobileRecord/index.vue'),
        meta: {
          title: 'queryRealMobileRecord',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'shadowAuditSetting',
        name: 'shadowAuditSetting',
        component: () => import(/* webpackChunkName: "channel" */ '../views/User/shadowAuditSetting/index.vue'),
        meta: {
          title: 'shadowAuditSetting',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'oldManRecharge',
        name: 'oldManRecharge',
        component: () => import(/* webpackChunkName: "channel" */ '../views/msgStat/oldManRecharge/index.vue'),
        meta: {
          title: 'oldManRecharge',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'oldManData',
        name: 'oldManData',
        component: () => import(/* webpackChunkName: "channel" */ '../views/msgStat/oldManData/index.vue'),
        meta: {
          title: 'oldManData',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'pgcTypeStatConfig',
        name: 'pgcTypeStatConfig',
        component: () => import(/* webpackChunkName: "channel" */ '../views/PGC/pgcTypeStatConfig/index.vue'),
        meta: {
          title: 'pgcTypeStatConfig',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'price',
        name: 'price',
        component: () => import(/* webpackChunkName: "channel" */ '../views/goddess/price.vue'),
        meta: {
          title: 'price',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'videoBenefitRule',
        name: 'videoBenefitRule',
        component: () => import(/* webpackChunkName: "channel" */ '../views/setting/videoBenefitRule/index.vue'),
        meta: {
          title: 'videoBenefitRule',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'imageContentPush',
        name: 'imageContentPush',
        component: () => import(/* webpackChunkName: "channel" */ '../views/imageContentPush/index.vue'),
        meta: {
          title: 'imageContentPush',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'customhi',
        name: 'customHi',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/CustomHi/index.vue'),
        meta: {
          title: '自定义回复',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'extraDemand',
        name: 'extraDemand',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/extraDemand/index.vue'),
        meta: {
          title: 'extraDemand',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'commend',
        name: 'commend',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/commend/index.vue'),
        meta: {
          title: 'commend',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'pgc-task-advances',
        name: 'pgc-task-advances',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/PGC/pgcTaskAdvances/index.vue'),
        meta: {
          title: 'pgc-task-advances',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'TVWall',
        name: 'TVWall',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/TVWall/index.vue'),
        meta: {
          title: '电视墙',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'tvstyleConfig',
        name: 'styleConfig',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/TVWall/styleConfig.vue'),
        meta: {
          title: '电视墙效果配置',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'vipPriceConfig',
        name: 'vipPriceConfig',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/Vip/vipPrice/index.vue'),
        meta: {
          title: '会员价格配置',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'vipRightsDesc',
        name: 'vipRightsDesc',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/Vip/vipRightsDesc/index.vue'),
        meta: {
          title: '会员文案',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'vipRechargeOrder',
        name: 'vipRechargeOrder',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/Vip/vipRechargeOrder/index.vue'),
        meta: {
          title: '会员开通流水',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'vipAccountInfo',
        name: 'vipAccountInfo',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/Vip/vipAccountInfo/index.vue'),
        meta: {
          title: '会员用户管理',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'vipAccountChange',
        name: 'vipAccountChange',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/Vip/vipAccountChange/index.vue'),
        meta: {
          title: '会员变更',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'LoginAudit',
        name: 'LoginAudit',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/LoginAudit/index.vue'),
        meta: {
          title: '审核单',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'replenishInvite',
        name: 'replenishInvite',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/invite/index.vue'),
        meta: {
          title: '邀请补发审核',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'imReplyRatioStat',
        name: 'imReplyRatioStat',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/msgStat/imReplyRatio/index.vue'),
        meta: {
          title: '消息回复率',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'redMumBReply',
        name: 'redMumBReply',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/msgStat/redMumReply/index.vue'),
        meta: {
          title: '红娘B类回复',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'pgcActive',
        name: 'pgcActive',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/msgStat/pgcActive/index.vue'),
        meta: {
          title: 'pgc活跃数据',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'pgcTaskScore',
        name: 'pgcTaskScore',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/msgStat/pgcTaskScore/index.vue'),
        meta: {
          title: 'pgc每日任务积分',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'imSessionDeepStat',
        name: 'imSessionDeepStat',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/msgStat/imSessionDeep/index.vue'),
        meta: {
          title: '会话深度',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'connectStat',
        name: 'connectStat',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/msgStat/connect/index.vue'),
        meta: {
          title: '通话数据统计',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: 'connectTimeStat',
        name: 'connectTimeStat',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/msgStat/connectTime/index.vue'),
        meta: {
          title: '平均通话时长',
          icon: 'guide',
          noCache: true
        }
      },
      {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import(/* webpackChunkName: "customhi" */ '../views/404.vue'),
        meta: {
          title: '404',
          icon: 'guide',
          noCache: true
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  }
]

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_ROUTER_BASE || process.env.BASE_URL),
  routes
})

export default router
